import React from 'react';
import { IconButton, Modal } from 'office-ui-fabric-react';
import { Col, Row } from 'react-flexbox-grid';
import Iframe from 'react-iframe';

export const ModalPagoEfectivo = ({modal, closeModal, urlCIP}) => {
  return(
    <Row center="xs">
      <Col xs={12} sm={8}>
        <Modal isOpen={modal} onDismiss={closeModal}>
          <Row>
            <Col xs={12} sm={12}>
              <IconButton
                iconProps={{ iconName: "Cancel" }}
                ariaLabel="Close popup modal"
                onClick={closeModal}
              />
            </Col>
          </Row>
          <Row className="fila-iframe">
            <Col xs={12} sm={12}>
              <Iframe
                url={urlCIP}
                id="iCIP"
                display="initial"
                position="relative"
                width="100%"
                height="100%"
              ></Iframe>
            </Col>
          </Row>
        </Modal>
      </Col>
    </Row>
  )
}
